module.exports = __webpack_public_path__ + "static/media/monitoring.b9babd95.svg";